import { render, staticRenderFns } from "./HuiyuanCenter.vue?vue&type=template&id=44246dee&scoped=true"
import script from "./HuiyuanCenter.vue?vue&type=script&lang=js"
export * from "./HuiyuanCenter.vue?vue&type=script&lang=js"
import style0 from "./HuiyuanCenter.vue?vue&type=style&index=0&id=44246dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44246dee",
  null
  
)

export default component.exports